import { NgModule } from '@angular/core';
import { GlobalAssetPipe } from './global-asset.pipe';
import { ImageUrlPipe } from './image-url.pipe';

import { FilterByPropertyPipe } from './filter-by-property.pipe';
import { FilterByStringPipe } from './filter-by-string.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';
import { StringFormaterPipe } from './string-formater.pipe';
import { SuperscripePipe } from './superscripe.pipe';
import { TruncateTextPipe } from './truncate-text.pipe';
import { YoutubeIdPipe } from './youtube-id.pipe';
import { YoutubeSafeUrlPipe } from './youtube-safe-url.pipe';
import { SafeUrlPipe } from './safe-url.pipe';

export const SHARED_MODULE_PIPES = [
    FilterByPropertyPipe,
    SafeHtmlPipe,
    SafeUrlPipe,
    StringFormaterPipe,
    GlobalAssetPipe,
    YoutubeIdPipe,
    YoutubeSafeUrlPipe,
    TruncateTextPipe,
    SuperscripePipe,
    FilterByStringPipe,
    ImageUrlPipe
];

@NgModule({
    imports: [],
    declarations: [...SHARED_MODULE_PIPES],
    exports: [...SHARED_MODULE_PIPES]
})
export class PipesModule {}
